export const DEVELOPMENT_MODE = process.env.DEVELOPMENT_MODE === "true";
export const IN_STAGING =  window.location.origin.includes("staging");
